import {Stack} from '@mui/material';
import React from 'react';

import {DataInfo} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {formatMasks, formatText} from 'presentation/utils';
import {OdontoProviderDataSectionProps} from './types';

const {guideDetails} = translations['pt-br'].privateFlow.guideFlow;

export function OdontoProviderDataSection({provider}: OdontoProviderDataSectionProps) {
	return (
		<Stack gap={1.5}>
			<DataInfo
				primaryTextFontSize="0.875rem"
				secondaryTextFontSize={!provider.nome ? '0.875rem' : '1rem'}
				removeItemTextMargin
				iconName="assignment-lnd-filled"
				primaryText={guideDetails.nameSocialReason}
				primaryTextColor="text.secondary"
				secondaryText={provider.nome ? formatText(provider.nome) : '-'}
				secondaryTextColor={provider.nome ? 'text.primary' : 'text.secondary'}
				removePaddingBottom
			/>
			<DataInfo
				primaryTextFontSize="0.875rem"
				secondaryTextFontSize={!provider.nomeFantasia ? '0.875rem' : '1rem'}
				removeItemTextMargin
				iconName="assignment-lnd-filled"
				primaryText={guideDetails.fantasyName}
				primaryTextColor="text.secondary"
				secondaryText={provider.nomeFantasia ? formatText(provider.nomeFantasia) : '-'}
				secondaryTextColor={provider.nomeFantasia ? 'text.primary' : 'text.secondary'}
				removePaddingBottom
			/>
			<DataInfo
				primaryTextFontSize="0.875rem"
				secondaryTextFontSize={!provider.nuDocumento ? '0.875rem' : '1rem'}
				removeItemTextMargin
				iconName="text-box-outline"
				primaryText={guideDetails.croDocument}
				primaryTextColor="text.secondary"
				secondaryText={provider.nuDocumento ? provider.nuDocumento : '-'}
				secondaryTextColor={provider.nuDocumento ? 'text.primary' : 'text.secondary'}
				removePaddingBottom
			/>
			<DataInfo
				primaryTextFontSize="0.875rem"
				secondaryTextFontSize={!provider.cnpj ? '0.875rem' : '1rem'}
				removeItemTextMargin
				iconName="assignment-outline"
				primaryText={guideDetails.juridicalName}
				primaryTextColor="text.secondary"
				secondaryText={provider.cnpj ? formatMasks('cnpj', String(provider.cnpj)) : '-'}
				secondaryTextColor={provider.cnpj ? 'text.primary' : 'text.secondary'}
				removePaddingBottom
			/>
		</Stack>
	);
}
